<template>
    <div>
        <v-container>
            <h1>Rerun Amlink Integration</h1>
            <h3>This will only work in nonprod!</h3>
            <br />
            <v-row>
                <v-col md="6" lg="4">
                    <TextInput
                        label="Account ID"
                        :value="accountId"
                        @change="accountId = $event">
                    </TextInput>
                </v-col>
            </v-row>
            <v-row>
                <v-col md="6" lg="4">
                    <FormButton label="Submit" @click="rerunAmlinkIntegration" :disabled="requesting"></FormButton>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import TextInput from '@/components/form/TextInput.vue';
    import FormButton from '@/components/form/FormButton.vue';

    import { AccountService } from '@/api/AccountService';

    export default {
        name: 'RerunAmlinkIntegration',
        components: {
            FormButton,
            TextInput
        },
        data () {
            return {
                accountId: "",
                requesting: false
            };
        },
        methods: {
            async rerunAmlinkIntegration () {
                this.requesting = true;
                await AccountService.rerunAmlinkIntegration({ id: this.accountId })
                .then(() => {
                    const message = this.accountId + ' successfully queued for rerunning integration. Check amlink in 5 minutes.';
                    this.$store.dispatch('toastSuccess', { Message: message });
                    this.accountId = "";
                })
                .catch(() => {

                })
                .finally(() => {
                    this.requesting = false;
                });
            }
        }
    };
</script>
